export const LIST_FILTER = {
  ALL_MODULE: 0,
  ASSIGNED: 1,
  UNASSIGNED: 2,
} as const
